import { useState } from "react";
import { useTranslation } from "react-i18next";
import {
  MotifModal,
  MotifModalHeader,
  MotifModalBody,
  MotifModalFooter,
  MotifButton,
} from "@ey-xd/motif-react";
import { useLazyDeletePaymentQuery } from "@/services/paymentStatus/paymentStatusReducer";
import { CommonModalHeader } from "@/components/Modal/CommonModalHeader/CommonModalHeader";
import { useTrans } from "@/components/Functions/dateFunc";
interface DeletePaymentProps {
  show: boolean;
  setShow: (value: boolean) => void;
  id: string | undefined;
  setDeleteErrorMessage: (message: string) => void;
  refetchPaymentList: () => void;
  paymentReference: string;
}

const DeletePayment = ({
  show,
  setShow,
  id,
  setDeleteErrorMessage,
  refetchPaymentList,
  paymentReference,
}: DeletePaymentProps) => {
  const { t } = useTranslation();
  const [isLoading, setIsLoading] = useState(false);
  const [deletePayment] = useLazyDeletePaymentQuery();

  const handleCancel = () => {
    setShow(false);
    setDeleteErrorMessage("");
  };

  const handleDelete = () => {
    setIsLoading(true);
    setDeleteErrorMessage("");
    deletePayment(id).then((response: any) => {
      if (response.data) {
        refetchPaymentList();
      } else {
        setDeleteErrorMessage(response?.error?.data?.message);
      }
      setIsLoading(false);
      setShow(false);
    });
  };
  return (
    <MotifModal
      onClose={handleCancel}
      show={show}
      focusTrapOptions={{
        tabbableOptions: {
          displayCheck: "none",
        },
      }}
    >
      <div className="confirmationModalWrapper creditor_disabling_model">
        <MotifModalHeader headerIcon={CommonModalHeader()}></MotifModalHeader>

        <MotifModalBody style={{ paddingTop: "0px" }}>
          {useTrans(
            t,
            t("pages.paymentStatus.deletePaymentMessage", {
              paymentReference: paymentReference,
            }),
            "paymentReference"
          )}
        </MotifModalBody>

        <MotifModalFooter>
          <MotifButton
            onClick={handleCancel}
            type={"button"}
            variant="secondary"
          >
            {t("pages.paymentStatus.filterForm.cancel")}
          </MotifButton>
          <MotifButton
            onClick={handleDelete}
            type={isLoading ? "loader" : "submit"}
            variant="primary"
            disabled={isLoading}
          >
            {t("pages.paymentStatus.confirm")}
          </MotifButton>
        </MotifModalFooter>
      </div>
    </MotifModal>
  );
};
export default DeletePayment;
